// src/lib/debtHistory.js
//
// Chunk 9b — best-effort recorder of debt-balance changes into
// debt_balance_history, so the Net Worth sparkline can plot true per-timestamp
// net worth. Every code path that changes debts.current_balance calls this
// AFTER the balance update. Non-blocking: the balance update is the source of
// truth, so a failed history insert only logs a warning.
//
import { supabase } from './supabase'

// source ∈ 'payment' | 'interest_accrual' | 'manual_update' | 'sweep' | 'creation'
export async function recordDebtBalance(debtId, balance, source, recordedAt = null) {
  if (!debtId) return
  try {
    const { error } = await supabase.from('debt_balance_history').insert({
      debt_id: debtId,
      balance: parseFloat(balance || 0),
      source,
      recorded_at: recordedAt || new Date().toISOString(),
    })
    if (error) console.warn('debt_balance_history insert failed:', error.message)
  } catch (e) {
    console.warn('debt_balance_history insert threw:', e?.message || e)
  }
}
